import React from "react";
import { countByStatus } from "../utils/orderUtils";

const OrderSummaryModal = ({ isOpen, onClose, filtered }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl max-w-sm w-full transform transition-all duration-300 scale-100"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-gradient-to-r from-purple-600 to-purple-700 px-4 py-3 rounded-t-xl flex items-center justify-between">
          <h3 className="font-display font-bold text-lg text-white">
            📊 Order Summary
          </h3>
          <button
            className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors duration-200"
            onClick={onClose}
          >
            ✖
          </button>
        </div>

        <ul className="divide-y divide-gray-200">
          <li className="flex justify-between items-center px-4 py-3 hover:bg-gray-50 transition-colors">
            <span className="font-text text-gray-700 font-medium text-sm">
              Total Orders
            </span>
            <span className="font-display text-lg font-bold text-purple-600">
              {filtered.length}
            </span>
          </li>
          <li className="flex justify-between items-center px-4 py-3 hover:bg-gray-50 transition-colors">
            <span className="font-text text-gray-700 font-medium flex items-center gap-2 text-sm">
              <span className="w-3 h-3 bg-orange-400 rounded-full"></span>
              Pending
            </span>
            <span className="font-display text-xl font-bold text-orange-600">
              {countByStatus(filtered, "pending")}
            </span>
          </li>
          <li className="flex justify-between items-center px-4 py-3 hover:bg-gray-50 transition-colors">
            <span className="font-text text-gray-700 font-medium flex items-center gap-2 text-sm">
              <span className="w-3 h-3 bg-blue-400 rounded-full"></span>
              Accepted
            </span>
            <span className="font-display text-lg font-bold text-blue-600">
              {countByStatus(filtered, "accept")}
            </span>
          </li>
          <li className="flex justify-between items-center px-4 py-3 hover:bg-gray-50 transition-colors">
            <span className="font-text text-gray-700 font-medium flex items-center gap-2 text-sm">
              <span className="w-3 h-3 bg-cyan-400 rounded-full"></span>Out for
              Delivery
            </span>
            <span className="font-display text-lg font-bold text-cyan-600">
              {countByStatus(filtered, "out for delivery")}
            </span>
          </li>
          <li className="flex justify-between items-center px-4 py-3 hover:bg-gray-50 transition-colors">
            <span className="font-text text-gray-700 font-medium flex items-center gap-2 text-sm">
              <span className="w-3 h-3 bg-indigo-400 rounded-full"></span>
              Delivery Pickup
            </span>
            <span className="font-display text-lg font-bold text-indigo-600">
              {countByStatus(filtered, "delivery pickup")}
            </span>
          </li>
          <li className="flex justify-between items-center px-4 py-3 hover:bg-gray-50 transition-colors">
            <span className="font-text text-gray-700 font-medium flex items-center gap-2 text-sm">
              <span className="w-3 h-3 bg-green-400 rounded-full"></span>
              Completed
            </span>
            <span className="font-display text-lg font-bold text-green-600">
              {countByStatus(filtered, "completed")}
            </span>
          </li>
          <li className="flex justify-between items-center px-4 py-3 hover:bg-gray-50 transition-colors rounded-b-xl">
            <span className="font-text text-gray-700 font-medium flex items-center gap-2 text-sm">
              <span className="w-3 h-3 bg-red-400 rounded-full"></span>
              Rejected
            </span>
            <span className="font-display text-lg font-bold text-red-600">
              {countByStatus(filtered, "reject")}
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default OrderSummaryModal;
